import React, { useEffect, useState, useRef } from 'react';
import MediaPlayer from '../utils/MediaPlayer';
import anime, { set } from 'animejs';
import './../css/common.css';
import './../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const audio1 = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5e5_1.mp3");
const audio2 = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5e5_2.mp3");
const audio3 = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5e5_3.mp3");
const audio4 = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5e5_4.mp3");

const audios = [audio1, audio2, audio3, audio4];
const pauseFunctions = [() => { }, () => { }, () => { }, () => { }];

const Module5e5 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module5e5;

    const [step, setStep] = useState(1);
    const [buttonHovered, setButtonHovered] = useState(0);
    const [playingGrid, setPlayingGrid] = useState(0);
    const playingGridRef = useRef(playingGrid);
    const [pause, setPause] = useState(true);
    const pauseRef = useRef(pause);
    const [selectedNote, setSelectedNote] = useState("0:0");
    const selectedNoteRef = useRef(selectedNote);
    const [showGrid, setShowGrid] = useState([true, false, false, false]);
    const [showOrange, setShowOrange] = useState(0);
    const [showOrangeHover, setShowOrangeHover] = useState(0);
    const [orangeAnim, setOrangeAnim] = useState(0);

    useEffect(() => {
        var tl = anime.timeline({
        });
        tl.add({
            targets: '#circle1',
            r: 120,
            duration: 2000,
            easing: 'spring(1, 80, 10, 0)',
        }, 200)
            .add({
                targets: '#circle1',
                r: 550,
                duration: 2000,
                easing: 'easeOutElastic(1, .8)',
            }, 1200)
            .add({
                targets: '#svg',
                zIndex: 1,
                duration: 1,
            }, 1500)
    }, []);

    const notesList = ["F7", "A7", "Ab7M", "D7", "Bb7", "E7", "Eb7", "D7", ""]

    const notes1 = ["F7", "", "Db7", "", "Gb7M", "", "B7", ""]
    const notes2 = ["F7", "", "A7", "Ab7M", "D7", "Db7", "C7", "B7"]
    const notes3 = ["Eb7", "Bb7", "A7", "Ab7M", "D7", "Db7", "C7", "B7"]
    const notes4 = ["A7", "Bb7", "E7", "Eb7", "D7", "Db7", "C7", "B7"]

    const orange =
        [[false, false, true, true, true, true, true, true],
        [true, true, true, false, false, false, false, false],
        [true, true, true, true, true, false, false, false]]

    const resetAllAudios = () => {
        audios.forEach(audio => {
            audio.pause();
            audio.currentTime = 0;
        })
    }

    const pauseAll = () => {
        pauseFunctions.forEach(func => {
            func();
        })
    }

    //Create an element wich is a div containg eight div with note
    //There is a white border around and between the 4th and 5th div
    function createGrid(notes, id, x, y, previousButton = false, previousFunc = () => { }) {
        return (
            <div
                style={{
                    position: 'absolute',
                    top: `${y}px`,
                    left: `${x}px`,
                    opacity: showGrid[id - 1] ? 1 : 0,
                    zIndex: showGrid[id - 1] ? 2 + id : 1,
                }}
                id={`grid${id}`}
                key={`grid${id}`} >
                <div style={{
                    position: 'absolute',
                    top: `0px`,
                    left: `0px`,
                    width: '360px',
                    height: '40px',
                    display: 'flex',
                    flexDirection: 'line',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    alignContent: 'center',
                    border: '2px solid white',
                    backgroundColor: "black",
                }}
                >
                    {notes.map((note, index) => {
                        let bg = 'transparent'
                        if ((showOrange == id || showOrangeHover == id) && orange[orangeAnim][index]) {
                            bg = '#fc733d'
                        } else if (selectedNoteRef.current == `${id}:${index}` && playingGridRef.current == id) {
                            bg = 'blue'
                        } else if (selectedNoteRef.current == `${id}:${index - 1}` && playingGridRef.current == id) {
                            bg = 'blue'
                        }
                        return (
                            <div style={{
                                position: 'relative',
                                width: '100%',
                                height: '100%',
                                borderRight: index === 3 ? '2px solid white' : 'none',
                                margin: '0px',
                                backgroundColor: bg
                            }}
                                id={`${id}:${index}`}
                                key={`${id}:${index}`}
                            >
                                <p style={{
                                    position: 'absolute',
                                    top: '-4px',
                                    left: '3px',
                                    width: '100%',
                                    height: '100%',
                                    textAlign: 'left',
                                    fontSize: '15px',
                                    color: "white",
                                }}>
                                    {note}
                                </p>
                            </div>
                        )
                    })}
                </div>
                {/* Add a play/pause button and  back button */}
                <img src={process.env.PUBLIC_URL + `/assets/images/module5e5/play${playingGridRef.current == id ? "2" : ""}.png`}
                    style={{
                        position: 'absolute',
                        top: '55px',
                        left: '3px',
                        zIndex: 3,
                    }}
                    id={`play${id}`}
                    //change image when hovered
                    onMouseEnter={(e) =>
                        e.target.src = process.env.PUBLIC_URL + "/assets/images/module5e5/play2.png"}
                    onMouseLeave={(e) =>
                        e.target.src = process.env.PUBLIC_URL + `/assets/images/module5e5/play${playingGridRef.current == id ? "2" : ""}.png`}
                />
                <img src={process.env.PUBLIC_URL + "/assets/images/module5e5/back.png"}
                    style={{
                        position: 'absolute',
                        top: '55px',
                        left: '25px',
                        zIndex: 3,
                    }}
                    id={`back${id}`}
                    //change image when hovered
                    onMouseEnter={(e) =>
                        e.target.src = process.env.PUBLIC_URL + "/assets/images/module5e5/back2.png"}
                    onMouseLeave={(e) =>
                        e.target.src = process.env.PUBLIC_URL + "/assets/images/module5e5/back.png"}
                />
                {previousButton &&
                    <img
                        style={{
                            position: 'absolute',
                            top: '-25px',
                            left: '340px',
                        }}
                        className='inflateButtonMore'
                        onClick={() => { pauseAll(); previousFunc() }}
                        src={process.env.PUBLIC_URL + "/assets/images/module5e5/4.png"} />}
            </div>
        )
    }

    function randomRoll(gridId, Index) {
        const note = notesList[Math.floor(Math.random() * notesList.length)];
        const element = document.getElementById(`${gridId}:${Index}`);
        element.innerHTML = `<p style="position: absolute; top: -4px; left: 3px; width: 50px; height: 50px; text-align: left; font-size: 15px; color: white;">${note}</p>`;
    }

    function randomRollMultiple(duration, gridId, IndexList) {
        const interval = 150
        IndexList.forEach((index) => {
            for (let i = 0; i < duration / interval; i++) {
                setTimeout(() => {
                    randomRoll(gridId, index);
                }, interval * i);
            }
        })
    }

    function updateGrid(gridId, notes) {
        notes.forEach((note, index) => {
            const element = document.getElementById(`${gridId}:${index}`);
            element.innerHTML = `<p style="position: absolute; top: -4px; left: 3px; width: 50px; height: 50px; text-align: left; font-size: 15px; color: white;">${note}</p>`;
        });
    }

    //Use anime JS to translate grid1
    function translateGrid(id) {
        anime({
            targets: `#grid${id}`,
            translateY: 120,
            zIndex: 3,
            duration: 1000,
            easing: 'easeInOutQuad',
        });
    }

    function playGrid(id) {
        const bpm = 77;
        //tempo is the time btw each note in ms
        const tempo = 60000 / bpm;
        const noteTimeline = anime.timeline({
            autoplay: false,
            easing: 'linear',
            duration: tempo,
            loop: false,
        });
        for (let i = 0; i < 10; i++) {
            for (let j = 0; j < 4; j++) {
                noteTimeline.add({
                    targets: `#${id}:${j}`,
                    begin: () => {
                        {
                            setSelectedNote(`${id}:${j * 2}`)
                            //console.log(`selected note is ${selectedNoteRef.current}`);
                            if (playingGridRef.current != id) {
                                //console.log("other selected", playingGridRef.current, id);
                                noteTimeline.restart();
                                setTimeout(() => {
                                    noteTimeline.pause();
                                }, 10);
                            }
                        }
                    },
                }, tempo * (i * 4 + j));
            }
        }
        //Add play pause capacity to play button
        const playButton = document.getElementById(`play${id}`);
        playButton.addEventListener('click', () => {
            //pause all others audio
            audios.forEach((audio) => {
                audio.pause();
            })
            //console.log(`play${id} clicked, state is ${pauseRef.current}`);
            if (pauseRef.current || playingGridRef.current != id) {
                setPlayingGrid(id);
                playingGridRef.current = id;
                setPause(false)
                noteTimeline.play();
                //Play the sound
                audios[id - 1].play();
            } else {
                setPlayingGrid(0);
                playingGridRef.current = 0;
                setPause(true);
                noteTimeline.pause();
                audios[id - 1].pause();
            }
        });
        //Add back button capacity
        const backButton = document.getElementById(`back${id}`);
        backButton.addEventListener('click', () => {
            if (playingGridRef.current != id) {
                return;
            }
            //console.log("back");
            setPlayingGrid(0);
            playingGridRef.current = 0;
            setPause(true);
            noteTimeline.restart();
            setTimeout(() => {
                noteTimeline.pause();
            }, 10);
            audios[id - 1].pause();
            audios[id - 1].currentTime = 0;
        });
        //Save the function
        pauseFunctions[id - 1] = () => {
            setPlayingGrid(0);
            playingGridRef.current = 0;
            setPause(true);
            noteTimeline.restart();
            setTimeout(() => {
                noteTimeline.pause();
            }, 10);
            audios[id - 1].pause();
            audios[id - 1].currentTime = 0;
        }
    }

    function playStep1() {
        pauseAll();
        setStep(2);
        setShowGrid([true, true, false, false])
        randomRollMultiple(3600, 2, [2, 3, 4, 5, 6, 7]);
        setShowOrange(2);
        setOrangeAnim(0);
        setTimeout(() => {
            translateGrid(2);
            updateGrid(2, notes2);
        }, 3600);
        setTimeout(() => {
            setShowOrange(0);
        }, 4600);
    }

    function playStep2() {
        pauseAll();
        setStep(3);
        setShowGrid([true, true, true, false])
        randomRollMultiple(3000, 3, [0, 1, 2]);
        setShowOrange(3);
        setOrangeAnim(1);
        setTimeout(() => {
            translateGrid(3);
            updateGrid(3, notes3);
        }, 3600);
        setTimeout(() => {
            setShowOrange(0);
        }, 4600);
    }

    function playStep3() {
        pauseAll();
        setStep(3);
        setShowGrid([true, true, false, true])
        randomRollMultiple(3000, 4, [0, 1, 2, 3, 4]);
        setShowOrange(4);
        setOrangeAnim(2);
        setTimeout(() => {
            translateGrid(4);
            updateGrid(4, notes4);
        }, 3600);
        setTimeout(() => {
            setShowOrange(0);
        }, 4600);
    }

    function resetToStep1() {
        pauseAll();
        setStep(1);
        setShowGrid([true, false, false, false])
        //Put everything in intitial position
        anime({
            targets: `#grid2`,
            translateY: 0,
            zIndex: 1,
            duration: 1000,
            easing: 'easeInOutQuad',
        });
        anime({
            targets: `#grid3`,
            translateY: 0,
            zIndex: 1,
            duration: 1000,
            easing: 'easeInOutQuad',
        });
        anime({
            targets: `#grid4`,
            translateY: 0,
            zIndex: 1,
            duration: 1000,
            easing: 'easeInOutQuad',
        });
    }

    function resetToStep2() {
        pauseAll();
        setStep(2);
        setShowGrid([true, true, false, false])
        //Put everything in intitial position
        anime({
            targets: `#grid3`,
            translateY: 0,
            zIndex: 1,
            duration: 1000,
            easing: 'easeInOutQuad',
        });
        anime({
            targets: `#grid4`,
            translateY: 0,
            zIndex: 1,
            duration: 1000,
            easing: 'easeInOutQuad',
        });
    }

    useEffect(() => {
        playGrid(1);
        playGrid(2);
        playGrid(3);
        playGrid(4);
    }, []);

    useEffect(() => {
        pauseRef.current = pause;
    }, [pause]);

    useEffect(() => {
        playingGridRef.current = playingGrid;
    }, [playingGrid]);

    useEffect(() => {
        selectedNoteRef.current = selectedNote;
    }, [selectedNote]);

    return (
        <>
            <div className="background">
                <img src={process.env.PUBLIC_URL + "/assets/images/module5e5/1.jpg"} style={{ position: 'absolute', top: '0px', left: '156px' }} />

                {createGrid(notes1, 1, 4, 130)}
                {createGrid(notes1, 2, 4, 130, true, resetToStep1)}
                {createGrid(notes2, 3, 4, 250, true, resetToStep2)}
                {createGrid(notes2, 4, 4, 250, true, resetToStep2)}


                <div style=
                    {{
                        position: 'absolute',
                        top: '314px',
                        left: '367px',
                        width: '292px',
                        height: '42px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '4px',
                        zIndex: 2
                    }}
                    onMouseEnter={() => {
                        setButtonHovered(1)
                        if (step === 1) {
                            setShowOrangeHover(1)
                            setOrangeAnim(0)
                        }
                    }}
                    onMouseLeave={() => {
                        setButtonHovered(0)
                        setShowOrangeHover(0)
                    }}
                    onClick={() => step == 1 && playStep1()}
                >
                    <div style={{
                        position: 'absolute',
                        top: '1px',
                        left: '1px',
                        width: '110px',
                        height: '36px',
                        backgroundColor: (buttonHovered === 1 && step === 1) ? "#fc733d" : "#ffe0a6",
                        borderRadius: '6px',
                        border: '2px solid #706551',
                    }}>
                        <p
                            style={{
                                position: 'absolute',
                                top: '-5px',
                                left: '-2px',
                                width: '110px',
                                height: '36px',
                                textAlign: 'center',
                                fontSize: '15px',
                                color: '#292621',
                            }}>
                            Db7 Gb7M B7
                        </p>
                    </div>
                    <img src={process.env.PUBLIC_URL + "/assets/images/module5e5/2.png"}
                        style={{
                            position: 'absolute',
                            top: '14px',
                            left: '109px'
                        }} />
                    <p style={{
                        position: 'absolute',
                        top: '-3px',
                        left: '131px',
                        width: '162px',
                        height: '42px',
                        textAlign: 'center',
                        fontSize: '14px',
                        color: '#292621',
                    }}>
                        A7 Ab7M D7 Db7 C7 B7
                    </p>
                </div>
                <div style=
                    {{
                        position: 'absolute',
                        top: '361px',
                        left: '367px',
                        width: '292px',
                        height: '42px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '4px',
                        zIndex: 2
                    }}
                    onMouseEnter={() => {
                        setButtonHovered(2)
                        if (step === 2) {
                            setShowOrangeHover(2)
                            setOrangeAnim(1)
                        }
                    }}
                    onMouseLeave={() => {
                        setButtonHovered(0)
                        setShowOrangeHover(0)
                    }}
                    onClick={() => step == 2 && playStep2()}
                >
                    <div style={{
                        position: 'absolute',
                        top: '1px',
                        left: '1px',
                        width: '110px',
                        height: '36px',
                        backgroundColor: (buttonHovered === 2 && step === 2) ? "#fc733d" : "#ffe0a6",
                        borderRadius: '6px',
                        border: '2px solid #706551',
                    }}>
                        <p
                            style={{
                                position: 'absolute',
                                top: '-5px',
                                left: '-2px',
                                width: '110px',
                                height: '36px',
                                textAlign: 'center',
                                fontSize: '15px',
                                color: '#292621',
                            }}>
                            F7 A7
                        </p>
                    </div>
                    <img src={process.env.PUBLIC_URL + "/assets/images/module5e5/2.png"}
                        style={{
                            position: 'absolute',
                            top: '14px',
                            left: '109px'
                        }} />
                    <p style={{
                        position: 'absolute',
                        top: '-3px',
                        left: '131px',
                        width: '162px',
                        height: '42px',
                        textAlign: 'center',
                        fontSize: '14px',
                        color: '#292621',
                    }}>
                        Eb7 Bb7 A7
                    </p>
                </div>
                <div style=
                    {{
                        position: 'absolute',
                        top: '408px',
                        left: '367px',
                        width: '292px',
                        height: '42px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '4px',
                        zIndex: 2
                    }}
                    onMouseEnter={() => {
                        setButtonHovered(3)
                        if (step === 2) {
                            setShowOrangeHover(2)
                            setOrangeAnim(2)
                        }
                    }}
                    onMouseLeave={() => {
                        setButtonHovered(0)
                        setShowOrangeHover(0)
                    }}
                    onClick={() => step == 2 && playStep3()}
                >
                    <div style={{
                        position: 'absolute',
                        top: '1px',
                        left: '1px',
                        width: '110px',
                        height: '36px',
                        backgroundColor: (buttonHovered === 3 && step === 2) ? "#fc733d" : "#ffe0a6",
                        borderRadius: '6px',
                        border: '2px solid #706551',
                    }}>
                        <p
                            style={{
                                position: 'absolute',
                                top: '-5px',
                                left: '-2px',
                                width: '110px',
                                height: '36px',
                                textAlign: 'center',
                                fontSize: '15px',
                                color: '#292621',
                            }}>
                            F7 A7 Ab7M D7
                        </p>
                    </div>
                    <img src={process.env.PUBLIC_URL + "/assets/images/module5e5/2.png"}
                        style={{
                            position: 'absolute',
                            top: '14px',
                            left: '109px'
                        }} />
                    <p style={{
                        position: 'absolute',
                        top: '-3px',
                        left: '131px',
                        width: '162px',
                        height: '42px',
                        textAlign: 'center',
                        fontSize: '14px',
                        color: '#292621',
                    }}>
                        A7 Bb7 E7 Eb7 D7
                    </p>
                </div>

                {(step === 1 && buttonHovered === 2 ||
                    step === 1 && buttonHovered === 3 ||
                    step === 2 && buttonHovered === 1 ||
                    step === 3) &&
                    <div className="info"
                        style={{
                            position: 'absolute',
                            top: '181px',
                            left: '509px',
                            width: '130px',
                            height: '100px',
                            zIndex: 2
                        }}
                    >
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5e5/3.png"} />
                        <p style={{
                            position: 'absolute',
                            top: '-7px',
                            left: '42px',
                            fontWeight: 'bold',
                            color: '#fc733d',
                        }}>
                            {texts.lang26}
                        </p>
                    </div>}

                <svg viewBox="0 0 660 500" style={{ zIndex: 3 }} id="svg">
                    <mask id="circles" maskUnits="objectBoundingBox">
                        <rect x="0" y="0" width="100%" height="100%" fill="white" />
                        <circle id="circle1" cx="470" cy="150" r="0" fill="black" />
                    </mask>

                    <rect x="0" y="0" width="100%" height="100%" fill="black" style={{ mask: 'url(#circles)' }} />
                </svg>

                {/* textes */}
                <p
                    style={{
                        position: 'absolute',
                        left: 10,
                        top: 0,
                        color: 'white',
                        fontSize: '15px',
                        zIndex: 15
                    }}
                >{texts.lang1}</p>

                <p
                    className="t1 text"
                    style={{
                        position: 'absolute',
                        top: '30px',
                        left: '20px',
                        color: 'white',
                        fontSize: '14px',
                        padding: '5px',
                        width: '400px',
                    }}
                >
                    {texts.lang24}
                </p>
                <p
                    className="t1 text"
                    style={{
                        position: 'absolute',
                        top: '266px',
                        right: '10px',
                        color: 'white',
                        fontSize: '16px',
                        padding: '5px',
                    }}
                >
                    {texts.lang25}
                </p>
            </div>
        </>
    );
}

export default Module5e5;
